import VideoGroup from './VideoGroup';

const LOW_PRIORITY = 500;

/**
 * Custom properties provider that adds a "Video" group
 * to the properties panel for Task elements.
 */
export default class VideoPropertiesProvider {
  constructor(propertiesPanel, injector) {
    propertiesPanel.registerProvider(LOW_PRIORITY, this);
    this._injector = injector;
  }

  getGroups(element) {
    return (groups) => {
      const videoGroup = VideoGroup(element, this._injector);

      if (videoGroup) {
        groups.push(videoGroup);
      }

      return groups;
    };
  }
}

VideoPropertiesProvider.$inject = ['propertiesPanel', 'injector'];
